import { User } from '../../../domain/users/models/User';

export interface UsersState {
    users: User[];
    selectedUser: User | undefined;
    pinnedAgentIds: string[];
    totalItems: number;
    pageNumber: number;
    pageSize: number;
    searchTerm: string;
    isLoading: boolean;
    error: string | undefined;
}

export const initialUsersState: UsersState = {
    users: [],
    selectedUser: undefined,
    pinnedAgentIds: [],
    totalItems: 0,
    pageNumber: 1,
    pageSize: 10,
    searchTerm: '',
    isLoading: false,
    error: undefined,
};
